import * as React from "react";
import { PhoneNumberUse } from "./admin-gql";
import { getPhoneUseDisplayNames } from "./displayNames";
export var SelectPhoneUse = function (props) {
    return (React.createElement("select", { className: "form-control", disabled: props.disabled || props.readonly, value: props.use, onChange: function (ev) { return props.onChange(ev.target.value); } }, Object.keys(PhoneNumberUse).map(function (x) { return (React.createElement("option", { value: x, key: x }, getPhoneUseDisplayNames(x) || x)); })));
};
//# sourceMappingURL=SelectPhoneUse.js.map